import { postRequest } from '../shared/utils';

export async function getHeaderScreenDetails(screenGridId, configSchema) {
  const body = {
    columns: ['id', 'screen_display_name_en'],
    screenGridId,
    schema: configSchema,
    table: 'mbd_screens',
    orderCol: 'screen_display_name_en',
    order: 'asc',
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    return { errors };
  }

  return data;
}
